import moment from 'moment/moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Insurances/branches'

export default {
  namespaced: true,
  state: {
    loading: false,
    reportData: {
      data: [],
      grandTotals: {
        counts: 0,
        prim: 0,
        komisyon: 0,
        chartData: {
          series: [],
          categories: [],
          chartTitle: null,
          yaxis: [],
        },
      },
    },
    filterParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    reportData(state) {
      return state.reportData
    },
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_REPORT_DATA(state, data) {
      state.reportData = data
    },
    /* RESET MUTATIONS */
    RESET_REPORT_DATA(state) {
      state.reportData = {
        data: [],
        grandTotals: {
          counts: 0,
          prim: 0,
          komisyon: 0,
          chartData: {
            series: [],
            categories: [],
            chartTitle: null,
            yaxis: [],
          },
        },
      }
    },
  },
  actions: {
    getReportData({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_REPORT_DATA')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_REPORT_DATA', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
